import { AppLog } from '../../../types';
import {
  AdministrationRoles,
  isAbleToSeeUIElement,
} from '../../utils/roles/client-roles';
import SharedToolbar from '../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../shared/analytics/module-list';
import SharedIconButton from '../../shared/buttons/shared-icon-button';
interface AppLogGridToolbarProps {
  administrationRoles: string[];
  handleExportMutate: () => void;
  isExporting: boolean;
  searchedLogs: AppLog[];
  isSearching: boolean;
}

export default function AppLogGridToolbar({
  administrationRoles,
  handleExportMutate,
  isExporting,
  searchedLogs,
  isSearching,
}: AppLogGridToolbarProps) {
  return (
    <SharedToolbar
      secondaryButtons={
        <>
          <SharedIconButton
            variant="export"
            onClick={() => handleExportMutate()}
            disabled={
              !isAbleToSeeUIElement(
                administrationRoles,
                AdministrationRoles.ExportAppLogs.value
              ) ||
              isSearching ||
              searchedLogs.length === 0
            }
            isLoading={isExporting}
            tooltipLabel="Export Results"
          />
          <SharedGridStateIconButton
            gridStateKey="loggingGridStates"
            module={ModuleList.modules.logging.name}
            section={ModuleList.modules.logging.sections.logging}
          />
        </>
      }
    />
  );
}
